var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container my-5 text-center"},[_c('h1',{staticClass:"display-1"},[_vm._v(" 404 ")]),_c('h3',[_vm._v(" Page Not Found ")]),_c('p',{staticClass:"text-muted"},[_vm._v(" The page you are looking for does not exist. ")]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/books"}},[_vm._v(" Back to Books ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }